import { render } from "./ScheduleFormStepWorkAreas.vue?vue&type=template&id=09f4f98e"
import script from "./ScheduleFormStepWorkAreas.vue?vue&type=script&lang=ts"
export * from "./ScheduleFormStepWorkAreas.vue?vue&type=script&lang=ts"
script.render = render

export default script